import React from "react"
import PageLayout from "./../components/templates/page-layout/page-layout"
import Home from "./../components/organisms/home/home"

export default function IndexPage() {
  return (
    <PageLayout hiddenLogo>
      <Home />
    </PageLayout>
  )
}
